// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContactAssetNavigation_a4QoO {
    display: flex;
    flex-direction: column;
    gap: 20px;
    scroll-behavior: smooth;

    .deleteContact_VxXHZ {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      color: #dc3545;
      gap: 7px;
      font-family: Inter;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: 16.9px;
      cursor: pointer;

      .icon_oDtf1 {
        display: flex;
        padding: 5px;
        align-items: center;
        gap: 10px;
        border-radius: 200px;
        background: #ededed;
      }
    }

    .parameters_SOAFf {
      display: flex;
      gap: 10px;
      align-items: center;
      cursor: pointer;
      color: var(--black-color);
      svg {
        width: 13px;
        height: 13px;
      }

      span {
        color: var(--_67-color);
      }
    }
    .searchIconsWrappers_HE2kp {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      background: var(--ececf1-background);
      cursor: pointer;
      -webkit-user-select: none;
              user-select: none;
      border-radius: 3px;
    }
    .parametersContainer_pdv3S {
      transition: all 300ms;
      -webkit-transition: all 300ms;
      -moz-transition: all 300ms;
      -ms-transition: all 300ms;
      -o-transition: all 300ms;
      overflow: hidden;
      interpolate-size: allow-keywords;
      display: flex;
      flex-direction: column;
      gap: 20px;
      ul {
        li {
          text-decoration: none;
          color: var(--_3-color);
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
        }
      }
    }
    ul {
      padding: 0;
      margin: 0;
      .active_tximv {
        border-left: 4px solid var(--_10a37f-background);
        border-radius: 10px;
        background-color: var(--ececf1-background);
        a {
          color: var(--_10a37f-background);
          font-weight: bold;
        }
      }
      li {
        list-style: none;
        height: 30px;
        display: flex;
        align-items: center;
        padding: 5px;

        a {
          text-decoration: none;
          color: #333333;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
        }
      }
    }
  }

  .dataInfo_tBxUM{
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    p{
      color: #000000;
    }
    span{
      color: var(--_71-color);
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/NavigationPopups/AgentNavigation/AgentNavigation.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;;IAEvB;MACE,WAAW;MACX,sBAAsB;MACtB,aAAa;MACb,mBAAmB;MACnB,cAAc;MACd,QAAQ;MACR,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB;MACnB,eAAe;;MAEf;QACE,aAAa;QACb,YAAY;QACZ,mBAAmB;QACnB,SAAS;QACT,oBAAoB;QACpB,mBAAmB;MACrB;IACF;;IAEA;MACE,aAAa;MACb,SAAS;MACT,mBAAmB;MACnB,eAAe;MACf,yBAAyB;MACzB;QACE,WAAW;QACX,YAAY;MACd;;MAEA;QACE,uBAAuB;MACzB;IACF;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,WAAW;MACX,YAAY;MACZ,oCAAoC;MACpC,eAAe;MACf,yBAAiB;cAAjB,iBAAiB;MACjB,kBAAkB;IACpB;IACA;MACE,qBAAqB;MACrB,6BAA6B;MAC7B,0BAA0B;MAC1B,yBAAyB;MACzB,wBAAwB;MACxB,gBAAgB;MAChB,gCAAgC;MAChC,aAAa;MACb,sBAAsB;MACtB,SAAS;MACT;QACE;UACE,qBAAqB;UACrB,sBAAsB;UACtB,WAAW;UACX,YAAY;UACZ,aAAa;UACb,mBAAmB;QACrB;MACF;IACF;IACA;MACE,UAAU;MACV,SAAS;MACT;QACE,gDAAgD;QAChD,mBAAmB;QACnB,0CAA0C;QAC1C;UACE,gCAAgC;UAChC,iBAAiB;QACnB;MACF;MACA;QACE,gBAAgB;QAChB,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,YAAY;;QAEZ;UACE,qBAAqB;UACrB,cAAc;UACd,WAAW;UACX,YAAY;UACZ,aAAa;UACb,mBAAmB;QACrB;MACF;IACF;EACF;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB;MACE,cAAc;IAChB;IACA;MACE,uBAAuB;IACzB;EACF","sourcesContent":[".ContactAssetNavigation {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    scroll-behavior: smooth;\n\n    .deleteContact {\n      width: 100%;\n      box-sizing: border-box;\n      display: flex;\n      align-items: center;\n      color: #dc3545;\n      gap: 7px;\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 16.9px;\n      cursor: pointer;\n\n      .icon {\n        display: flex;\n        padding: 5px;\n        align-items: center;\n        gap: 10px;\n        border-radius: 200px;\n        background: #ededed;\n      }\n    }\n\n    .parameters {\n      display: flex;\n      gap: 10px;\n      align-items: center;\n      cursor: pointer;\n      color: var(--black-color);\n      svg {\n        width: 13px;\n        height: 13px;\n      }\n\n      span {\n        color: var(--_67-color);\n      }\n    }\n    .searchIconsWrappers {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 18px;\n      height: 18px;\n      background: var(--ececf1-background);\n      cursor: pointer;\n      user-select: none;\n      border-radius: 3px;\n    }\n    .parametersContainer {\n      transition: all 300ms;\n      -webkit-transition: all 300ms;\n      -moz-transition: all 300ms;\n      -ms-transition: all 300ms;\n      -o-transition: all 300ms;\n      overflow: hidden;\n      interpolate-size: allow-keywords;\n      display: flex;\n      flex-direction: column;\n      gap: 20px;\n      ul {\n        li {\n          text-decoration: none;\n          color: var(--_3-color);\n          width: 100%;\n          height: 100%;\n          display: flex;\n          align-items: center;\n        }\n      }\n    }\n    ul {\n      padding: 0;\n      margin: 0;\n      .active {\n        border-left: 4px solid var(--_10a37f-background);\n        border-radius: 10px;\n        background-color: var(--ececf1-background);\n        a {\n          color: var(--_10a37f-background);\n          font-weight: bold;\n        }\n      }\n      li {\n        list-style: none;\n        height: 30px;\n        display: flex;\n        align-items: center;\n        padding: 5px;\n\n        a {\n          text-decoration: none;\n          color: #333333;\n          width: 100%;\n          height: 100%;\n          display: flex;\n          align-items: center;\n        }\n      }\n    }\n  }\n\n  .dataInfo{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    align-items: center;\n    p{\n      color: #000000;\n    }\n    span{\n      color: var(--_71-color);\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ContactAssetNavigation": `ContactAssetNavigation_a4QoO`,
	"deleteContact": `deleteContact_VxXHZ`,
	"icon": `icon_oDtf1`,
	"parameters": `parameters_SOAFf`,
	"searchIconsWrappers": `searchIconsWrappers_HE2kp`,
	"parametersContainer": `parametersContainer_pdv3S`,
	"active": `active_tximv`,
	"dataInfo": `dataInfo_tBxUM`
};
export default ___CSS_LOADER_EXPORT___;
